import React, { useState, useEffect } from 'react';
import {
	TextField,
	// Avatar,
	Typography,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
} from '@mui/material';
import Grid from '@mui/material/Grid2';

interface UserCardProps {
	_id: string;
	firstName: string;
	lastName: string;
	email: string;
	mobile: string;
	status: number;
	createdAt?: string;
	updatedAt?: string;
	profileImage?: string;
	shippingAddress?: {
		fullName: string;
		email: string;
		phone: string;
		address: string;
		state: string;
		zipCode: string;
		country: string;
		city: string;
		active: boolean;
		_id: string;
	}[];
}

interface ViewUserProps {
	product: UserCardProps | null;
	isDisabled: boolean;
}

const ViewUser: React.FC<ViewUserProps> = ({ product, isDisabled }) => {
	const [formData, setFormData] = useState<UserCardProps>({
		_id: '',
		firstName: '',
		lastName: '',
		email: '',
		mobile: '',
		status: 0,
		profileImage: '',
		shippingAddress: [],
	});

	useEffect(() => {
		if (product) {
			setFormData(product);
		}
	}, [product]);

	return (
		<form id="create-contact-form">
			<Grid container spacing={2}>
				{/* <Grid size={{ xs: 12 }}>
					<Avatar
						alt="Profile Image"
						src={formData.profileImage}
						sx={{ width: 56, height: 56 }}
					/>
				</Grid> */}
				<Grid size={{ xs: 12 }} sx={{ marginTop: '10px' }}>
					<TextField
						label="First Name"
						name="firstName"
						value={formData.firstName}
						fullWidth
						size="small"
						disabled={isDisabled}
					/>
				</Grid>
				<Grid size={{ xs: 12 }}>
					<TextField
						label="Last Name"
						name="lastName"
						value={formData.lastName}
						fullWidth
						size="small"
						disabled={isDisabled}
					/>
				</Grid>
				<Grid size={{ xs: 12 }}>
					<TextField
						label="Email"
						name="email"
						value={formData.email}
						fullWidth
						size="small"
						disabled={isDisabled}
					/>
				</Grid>
				<Grid size={{ xs: 12 }}>
					<TextField
						label="Mobile"
						name="mobile"
						value={formData.mobile}
						fullWidth
						size="small"
						disabled={isDisabled}
					/>
				</Grid>

				{formData.shippingAddress && formData.shippingAddress.length > 0 && (
					<Grid size={{ xs: 12 }}>
						<Typography variant="h6">Shipping Address</Typography>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>Full Name</TableCell>
									<TableCell>Email</TableCell>
									<TableCell>Phone</TableCell>
									<TableCell>Address</TableCell>
									<TableCell>State</TableCell>
									<TableCell>Zip Code</TableCell>
									<TableCell>Country</TableCell>
									<TableCell>City</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{formData.shippingAddress.map((address) => (
									<TableRow key={address._id}>
										<TableCell>{address.fullName}</TableCell>
										<TableCell>{address.email}</TableCell>
										<TableCell>{address.phone}</TableCell>
										<TableCell>{address.address}</TableCell>
										<TableCell>{address.state}</TableCell>
										<TableCell>{address.zipCode}</TableCell>
										<TableCell>{address.country}</TableCell>
										<TableCell>{address.city}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</Grid>
				)}
			</Grid>
		</form>
	);
};

export default ViewUser;
